export function formatMonthYear(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-AU', { month: 'long', year: 'numeric', timeZone: 'UTC' })
}
